<template><article><h1>自定义数据</h1>
<h3 id="当-data-为字符串数组类型"><a class="header-anchor" href="#当-data-为字符串数组类型" aria-hidden="true">#</a> 当 data 为字符串数组类型</h3>
<p><example :value="example1"></example></p>
<h3 id="当-data-为对象数组类型"><a class="header-anchor" href="#当-data-为对象数组类型" aria-hidden="true">#</a> 当 data 为对象数组类型</h3>
<p>修改 data-label 和 data-value 可以改变绑定值的字段和展示的字段。</p>
<p><example :value="example2"></example></p>
<div class="warning custom-block"><p class="custom-block-title">WARNING</p>
<p>理论上 value 支持对象类型，但是得确保对象的引用是一致的，否则组件无法判断两个对象是否相等。</p>
</div>
<h3 id="当-data-为对象类型"><a class="header-anchor" href="#当-data-为对象类型" aria-hidden="true">#</a> 当 data 为对象类型</h3>
<p><example :value="example3"></example></p>
<div class="warning custom-block"><p class="custom-block-title">WARNING</p>
<p>因为对象的 key 是字符串，所以 <code v-pre>v-model</code> 只能传递字符串类型。</p>
<p>不过使用 <code v-pre>@change</code> 就能轻松转为数字类型：</p>
<pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">vue-slider</span>
  <span class="hljs-attr">:value</span>=<span class="hljs-string">"''+ value"</span>
  <span class="hljs-attr">@change</span>=<span class="hljs-string">"val =&gt; value = +val"</span>
/&gt;</span>
</code></pre>
</div>
</article></template>

<script>
  import examples from '@/examples/data.ts'
  export default {
    data () {
      return {
        ...examples
      }
    }
  }
</script>